import { render } from "./SharedHeader.vue?vue&type=template&id=8a90430e&scoped=true"
import script from "./SharedHeader.vue?vue&type=script&lang=js"
export * from "./SharedHeader.vue?vue&type=script&lang=js"

import "./SharedHeader.vue?vue&type=style&index=0&id=8a90430e&scoped=true&lang=css"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a90430e"]])

export default __exports__